@if (job) {
  <form name="deleteForm" (ngSubmit)="confirmDelete(job.id!)">
    <div class="modal-header">
      <h4 class="modal-title" data-cy="jobDeleteDialogHeading" jhiTranslate="entity.delete.title">Confirm delete operation</h4>
    </div>

    <div class="modal-body">
      <jhi-alert-error></jhi-alert-error>
      <p id="jhi-delete-job-heading" jhiTranslate="recruitmentApp.job.delete.question" [translateValues]="{ id: job.id }">
        Are you sure you want to delete Job {{ job.id }}?
      </p>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="cancel()">
        <fa-icon icon="ban"></fa-icon>&nbsp;<span jhiTranslate="entity.action.cancel">Cancel</span>
      </button>

      <button id="jhi-confirm-delete-job" data-cy="entityConfirmDeleteButton" type="submit" class="btn btn-danger">
        <fa-icon icon="times"></fa-icon>&nbsp;<span jhiTranslate="entity.action.delete">Delete</span>
      </button>
    </div>
  </form>
}
